import * as action from "./actions";

export const getNotifications = id => {
  return {
    type: action.GET_NOTIFICATIONS,
    payload: id
  };
};

export const refreshNotifications = id => {
  return {
    type: action.REFRESH_NOTIFICATIONS,
    payload: id
  };
};

export const setNotifications = notifications => {
  return {
    type: action.SET_NOTIFICATIONS,
    payload: notifications
  };
};

const ACTION_HANDLERS = {
  [action.GET_NOTIFICATIONS]: (state, action) => {
    return { ...state };
  },
  [action.SET_NOTIFICATIONS]: (state, action) => {
    return { ...state, ...action.payload };
  },
  [action.REFRESH_NOTIFICATIONS]: (state, action) => {
    return { ...state, ...action.payload };
  }
};

let defaultState = {
  notifications: []
};

export const reducer = (state = defaultState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
